/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetInventoryEntriesByShelfInput = {
  shelfNumber: string;
};

export type SearchUnitsByEanInput = {
  ean: string;
};

export type SearchUnitsByTextInput = {
  query: string;
};

export type SearchProductsByEanQueryVariables = Exact<{
  searchProductsByEanInput: Types.SearchUnitsByEanInput;
  isAlwaysInbound?: boolean | null | undefined;
}>;

export type SearchProductsByEanQuery = {
  searchUnitsByEan: {
    units: Array<{
      product: {
        bio: boolean | null;
        imageUrl: string | null;
        name: string;
        sku: string;
        countryOfOrigin: { code: string | null };
        inventoryEntry: { shelfNumber: string | null; stock: { shelf: number } | null };
      };
    }>;
  };
};

export type SearchProductsByTextQueryVariables = Exact<{
  searchProductsByTextInput: Types.SearchUnitsByTextInput;
}>;

export type SearchProductsByTextQuery = {
  searchUnitsByText: {
    units: Array<{
      product: {
        bio: boolean | null;
        imageUrl: string | null;
        name: string;
        sku: string;
        countryOfOrigin: { code: string | null };
        inventoryEntry: { shelfNumber: string | null; stock: { shelf: number } | null };
      };
    }>;
  };
};

export type GetProductsByShelfQueryVariables = Exact<{
  input: Types.GetInventoryEntriesByShelfInput;
}>;

export type GetProductsByShelfQuery = {
  getInventoryEntriesByShelf: {
    inventoryEntries: Array<{
      product: {
        bio: boolean | null;
        imageUrl: string | null;
        name: string;
        sku: string;
        numberOfShelfFacings: number | null;
        numberOfShelfStackings: number | null;
        isShelvedInHandlingUnits: boolean | null;
        countryOfOrigin: { code: string | null };
        inventoryEntry: { shelfNumber: string | null; stock: { shelf: number } | null };
      } | null;
    }>;
  };
};

export const SearchProductsByEanDocument = gql`
  query searchProductsByEan(
    $searchProductsByEanInput: SearchUnitsByEanInput!
    $isAlwaysInbound: Boolean
  ) {
    searchUnitsByEan(
      searchUnitsByEanInput: $searchProductsByEanInput
      isAlwaysInbound: $isAlwaysInbound
    ) {
      units {
        product {
          bio
          imageUrl
          name
          sku
          countryOfOrigin {
            code
          }
          inventoryEntry {
            shelfNumber
            stock {
              shelf
            }
          }
        }
      }
    }
  }
`;

/**
 * __useSearchProductsByEanQuery__
 *
 * To run a query within a React component, call `useSearchProductsByEanQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProductsByEanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProductsByEanQuery({
 *   variables: {
 *      searchProductsByEanInput: // value for 'searchProductsByEanInput'
 *      isAlwaysInbound: // value for 'isAlwaysInbound'
 *   },
 * });
 */
export function useSearchProductsByEanQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchProductsByEanQuery,
    SearchProductsByEanQueryVariables
  > &
    ({ variables: SearchProductsByEanQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchProductsByEanQuery, SearchProductsByEanQueryVariables>(
    SearchProductsByEanDocument,
    options,
  );
}
export function useSearchProductsByEanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchProductsByEanQuery,
    SearchProductsByEanQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchProductsByEanQuery, SearchProductsByEanQueryVariables>(
    SearchProductsByEanDocument,
    options,
  );
}
// @ts-ignore
export function useSearchProductsByEanSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchProductsByEanQuery,
    SearchProductsByEanQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SearchProductsByEanQuery, SearchProductsByEanQueryVariables>;
export function useSearchProductsByEanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchProductsByEanQuery, SearchProductsByEanQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  SearchProductsByEanQuery | undefined,
  SearchProductsByEanQueryVariables
>;
export function useSearchProductsByEanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchProductsByEanQuery, SearchProductsByEanQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchProductsByEanQuery, SearchProductsByEanQueryVariables>(
    SearchProductsByEanDocument,
    options,
  );
}
export type SearchProductsByEanQueryHookResult = ReturnType<typeof useSearchProductsByEanQuery>;
export type SearchProductsByEanLazyQueryHookResult = ReturnType<
  typeof useSearchProductsByEanLazyQuery
>;
export type SearchProductsByEanSuspenseQueryHookResult = ReturnType<
  typeof useSearchProductsByEanSuspenseQuery
>;
export type SearchProductsByEanQueryResult = Apollo.QueryResult<
  SearchProductsByEanQuery,
  SearchProductsByEanQueryVariables
>;
export const SearchProductsByTextDocument = gql`
  query searchProductsByText($searchProductsByTextInput: SearchUnitsByTextInput!) {
    searchUnitsByText(searchUnitsByTextInput: $searchProductsByTextInput) {
      units {
        product {
          bio
          imageUrl
          name
          sku
          countryOfOrigin {
            code
          }
          inventoryEntry {
            shelfNumber
            stock {
              shelf
            }
          }
        }
      }
    }
  }
`;

/**
 * __useSearchProductsByTextQuery__
 *
 * To run a query within a React component, call `useSearchProductsByTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProductsByTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProductsByTextQuery({
 *   variables: {
 *      searchProductsByTextInput: // value for 'searchProductsByTextInput'
 *   },
 * });
 */
export function useSearchProductsByTextQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchProductsByTextQuery,
    SearchProductsByTextQueryVariables
  > &
    ({ variables: SearchProductsByTextQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchProductsByTextQuery, SearchProductsByTextQueryVariables>(
    SearchProductsByTextDocument,
    options,
  );
}
export function useSearchProductsByTextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchProductsByTextQuery,
    SearchProductsByTextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchProductsByTextQuery, SearchProductsByTextQueryVariables>(
    SearchProductsByTextDocument,
    options,
  );
}
// @ts-ignore
export function useSearchProductsByTextSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchProductsByTextQuery,
    SearchProductsByTextQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SearchProductsByTextQuery, SearchProductsByTextQueryVariables>;
export function useSearchProductsByTextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchProductsByTextQuery,
        SearchProductsByTextQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SearchProductsByTextQuery | undefined,
  SearchProductsByTextQueryVariables
>;
export function useSearchProductsByTextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchProductsByTextQuery,
        SearchProductsByTextQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchProductsByTextQuery, SearchProductsByTextQueryVariables>(
    SearchProductsByTextDocument,
    options,
  );
}
export type SearchProductsByTextQueryHookResult = ReturnType<typeof useSearchProductsByTextQuery>;
export type SearchProductsByTextLazyQueryHookResult = ReturnType<
  typeof useSearchProductsByTextLazyQuery
>;
export type SearchProductsByTextSuspenseQueryHookResult = ReturnType<
  typeof useSearchProductsByTextSuspenseQuery
>;
export type SearchProductsByTextQueryResult = Apollo.QueryResult<
  SearchProductsByTextQuery,
  SearchProductsByTextQueryVariables
>;
export const GetProductsByShelfDocument = gql`
  query getProductsByShelf($input: GetInventoryEntriesByShelfInput!) {
    getInventoryEntriesByShelf(input: $input) {
      inventoryEntries {
        product {
          bio
          imageUrl
          name
          sku
          countryOfOrigin {
            code
          }
          numberOfShelfFacings
          numberOfShelfStackings
          isShelvedInHandlingUnits
          inventoryEntry {
            shelfNumber
            stock {
              shelf
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetProductsByShelfQuery__
 *
 * To run a query within a React component, call `useGetProductsByShelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsByShelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsByShelfQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductsByShelfQuery(
  baseOptions: Apollo.QueryHookOptions<GetProductsByShelfQuery, GetProductsByShelfQueryVariables> &
    ({ variables: GetProductsByShelfQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProductsByShelfQuery, GetProductsByShelfQueryVariables>(
    GetProductsByShelfDocument,
    options,
  );
}
export function useGetProductsByShelfLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProductsByShelfQuery,
    GetProductsByShelfQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProductsByShelfQuery, GetProductsByShelfQueryVariables>(
    GetProductsByShelfDocument,
    options,
  );
}
// @ts-ignore
export function useGetProductsByShelfSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProductsByShelfQuery,
    GetProductsByShelfQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetProductsByShelfQuery, GetProductsByShelfQueryVariables>;
export function useGetProductsByShelfSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProductsByShelfQuery, GetProductsByShelfQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetProductsByShelfQuery | undefined,
  GetProductsByShelfQueryVariables
>;
export function useGetProductsByShelfSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProductsByShelfQuery, GetProductsByShelfQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProductsByShelfQuery, GetProductsByShelfQueryVariables>(
    GetProductsByShelfDocument,
    options,
  );
}
export type GetProductsByShelfQueryHookResult = ReturnType<typeof useGetProductsByShelfQuery>;
export type GetProductsByShelfLazyQueryHookResult = ReturnType<
  typeof useGetProductsByShelfLazyQuery
>;
export type GetProductsByShelfSuspenseQueryHookResult = ReturnType<
  typeof useGetProductsByShelfSuspenseQuery
>;
export type GetProductsByShelfQueryResult = Apollo.QueryResult<
  GetProductsByShelfQuery,
  GetProductsByShelfQueryVariables
>;
